import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  HealthOrganizationCheckoutSummary,
  UserCheckout,
  UsersGroupedByCategory,
} from "src/app/core/model/v2/practice/RoleGroupedUser";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { Location } from "@angular/common";
import { EmployerService } from "src/app/core/services/v2/employer.service";
import { UserService } from "src/app/core/services/v2/user.service";
import { SharedDataService } from "src/app/core/services/v2/shared-emp-subscription.service";
import { CreditCardComponent } from "src/app/market-place/market-place-home/product-checkout/credit-card/credit-card.component";
import { MatDialog } from "@angular/material/dialog";
import { UtilsService } from "src/app/core/services/v2/utils.service";
import { AppyUser } from "src/app/core/model/v2/AppyUser";
import { PaymentProfile } from "src/app/core/models/UserPaymentProfile/userPaymentProfile";
import { PatientFamilyDetailsComponent } from "../patient-family-details/patient-family-details.component";
import { PatientService } from "src/app/core/services/v2/patient.service";

@Component({
  selector: 'app-patient-checkout',

  templateUrl: './patient-checkout.component.html',

  styleUrls: ['./patient-checkout.component.scss'],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class PatientCheckoutComponent implements OnInit {
  roleGroupedUsers: UsersGroupedByCategory[];
  healthOrganizationCheckoutSummary: HealthOrganizationCheckoutSummary;
  errorMessage: string;
  changeCard: boolean = false;
  // subscriptionType: number;
  summaryAmount: number = 0;
 customerProfileId: string;
 isCheckoutInfoLoaded: boolean = false;
 isAgreementChecked = false;

  // userAppy: AppyUser;
  creditCards: PaymentProfile[];
  columnsToDisplay = [
    "roleCategory",
    "numberOfPersons",
    "totalPendingOneTimeFee",
    "familyCount",
  ];
  activationType: string;
  selectedType: number = 0;

  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  displayedColumns = [
    "name",
    // "roleCategory",
    "pendingOneTimeFee",
    "monthlyFee",
  ];
  expandedElement: UserCheckout | null;
  subscriptionType: number | undefined;
  selectedPlan: any; // Holds the selected plan data
  planId: number;
  familyCount = 0;

  subscriptionPlans = [
    {
      id: 1,
      name: "Health",
      price:'$9.25',
      features: [
        "Teladoc ($0 Visit Fee)",
        "Health Advocate Solutions",
        "NB Fitness",
        "NB Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx"
      ]
    },
    {
      id: 2,
      name: "Health Plus",
      price:'$21.35',
    
      features: [
        "Teladoc ($0 Visit Fee)",
        "Health Advocate Solutions",
        "NB Fitness",
        "NB Rx",
        "Manifest Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx",
      ]
    },
    {
      id: 3,
      name: "Mental Health",
      price:'$15.75',

      features: [
        "Teladoc Mental Health ($0 Visit Fee)",
        "Health Advocate Solutions",
        "NB Fitness",
        "NB Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx",
      ]
    },
    {
      id: 4,
      name: "Premium Health",
      price:'$41.95',

      features: [
        "Teladoc ($0 Visit Fee)",
        "Teladoc Mental Health ($0 Visit Fee)",
       " Manifest Rx",
        "Health Advocate Solutions",
        "NB Fitness",
        "LifeLock Essential Individual",
        "NB Pet Telehealth",
        "NB Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx",
      ]
    },
    {
      id: 5,
      name: "Health Advocate",
      price:'$3.65',

      features: [
        "Health Advocate Solutions",
      ]
    },
    // Add more plans as needed
  ];
  planDetails: any[] = []; // Holds the data to be displayed in the table
  // userId: number;
  employerId: number;
  user: any = [];
  checkoutInfo: any;
  taxRate: number = 8.25 / 100; // Tax rate: 8.25%
  familycount = 0; // Update this based on the API response and selections
  patientId:number;
  constructor(
    private router: Router,
    private practiceService: PracticeService,
    private loaderService: WindowLoaderService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private employerService: EmployerService,
    private userService: UserService,
    private sharedDataService: SharedDataService,
    public dialog: MatDialog,
    private utils: UtilsService,
    private patientService:PatientService
    
  ) {}

  ngOnInit() {
  
this.GetPaymentInformation();
const id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    this.selectedPlan = this.subscriptionPlans.find((plan) => plan.id === id);
    console.log('Selected Plan ID:',  this.selectedPlan);
    if (this.selectedPlan) {
      console.log('Selected Plan:', this.selectedPlan);
      this.updateTableDataBasedOnSelectedPlan(); // Method to update data dynamically
      // this.getPatinetCheckOutInfomation();
      this.getUserDetails();
      // this.getPatientDetailsByUserId();

       // Retrieve additional parameters from the shared service
    const employerId = this.sharedDataService.getData('employerId');
    const patientId = this.sharedDataService.getData('patientId');
    const subscriptionTypeId = this.selectedPlan.id;

    console.log('Employer ID:', employerId);
    console.log('Patient ID:', patientId);
    console.log('Subscription Type ID:', subscriptionTypeId);

    } else {
      console.error('No matching plan found for ID:', id);
    }
    // if (this.selectedPlan) {
    //   this.summaryAmount = this.selectedPlan.price * this.selectedPlan.employeesCount;
    // }
    this.calculateSummaryAmount();

}

calculateSummaryAmount(): void {
  if (this.planDetails && this.planDetails.length > 0) {
    this.summaryAmount = this.planDetails.reduce((total, element) => {
      return total + element.price * element.employeesCount;
    }, 0);
  }
}

updateTableDataBasedOnSelectedPlan() {
  if (this.selectedPlan) {
    // Assuming you want to display plan details like features

    this.planDetails = [{
      planName: this.selectedPlan.name,  // Plan name
      // price: this.selectedPlan.price,  // Example fee, adjust based on your requirements
      price: parseFloat(this.selectedPlan.price.replace('$', '')),  // Convert price to number by removing the '$' sign
     description: 'A comprehensive plan with various health benefits'  // Example description
    }];

    console.log('Plan Details:', this.planDetails);
  }
}
get totalAmount(): number {
  return this.planDetails.reduce((total, element) => total + (element.price), 0);
}
get taxAmount(): number {
  return this.totalAmount * this.taxRate; // Calculate tax
}

get totalWithTax(): number {
  return this.totalAmount + this.taxAmount; // Total amount including tax
}
getUserDetails() {
  this.loaderService.show();
  this.userService.getUserDetails().subscribe(
    (userDetails) => {
      this.user = userDetails;
      console.log("user", this.user);
      // this.userId = userDetails.id;
      this.patientId = userDetails.patientId
      // console.log("This is userId: ", this.userId);
      console.log("This is patientId: ", this.patientId);
      this.getPatinetCheckOutInfomation();
      // this.getPatientDetailsByUserId();

      this.loaderService.hide();

    },
    (error) => { console.error(error); }
  );
}

getPatinetCheckOutInfomation() {
  this.patientService.getPatientSubscriptionCheckOutInfomation(
    this.user.patientId,
    this.user.employerId = 0,
    this.subscriptionType = this.selectedPlan.id,
  ).subscribe(
    (checkoutSummary) => {
      console.log("checkoutSummary", checkoutSummary.result);
      if (checkoutSummary && checkoutSummary.resultStatus && checkoutSummary.resultStatus.isSuccess) {
        this.checkoutInfo = checkoutSummary.result;
        this.healthOrganizationCheckoutSummary = checkoutSummary.result;

        console.log("checkoutInfo:", this.checkoutInfo);
        this.planDetails = this.planDetails.map(plan => {
          return {
            ...plan,
            employeesCount: this.checkoutInfo && this.checkoutInfo.employeesCount ? this.checkoutInfo.employeesCount : 0,
            totalPlanAmount: this.checkoutInfo && this.checkoutInfo.totalPlanAmount ? this.checkoutInfo.totalPlanAmount : 0
          };
        });

        console.log("Updated Plan Details:", this.planDetails);
        console.log("Individual Due Amount:", this.checkoutInfo.individualDueAmount);
        console.log("Total Due Amount:", this.checkoutInfo.totalPlanAmount);

        // Set flag to true to enable the button
        this.isCheckoutInfoLoaded = true;
      } else {
        // Handle API failure
        console.warn("API request failed:", checkoutSummary && checkoutSummary.resultStatus && checkoutSummary.resultStatus.message || "Unknown error occurred.");
        const errorMessage = checkoutSummary && checkoutSummary.resultStatus && checkoutSummary.resultStatus.errorMessages
          ? checkoutSummary.resultStatus.errorMessages.join(", ")
          : "Failed to fetch subscription details.";
        this.utils.showMessageSnackBar(errorMessage, true);
        
        // Set flag to false to disable the button
        this.isCheckoutInfoLoaded = false;
      }
    },
    (error) => {
      console.error("Error fetching checkout information:", error);
      this.utils.showMessageSnackBar("Error fetching checkout information. Please try again.", true);
      
      // Set flag to false to disable the button
      this.isCheckoutInfoLoaded = false;
    }
  );
}  




  
  goBack() {
    this.location.back();
  }

  completeCheckout() {
    this.pay();
  }

  reload() {
    // this.LoadCheckoutSummary();
  }

  addChangeCard() {
    this.changeCard = !this.changeCard;
    console.log("add change card");
  }



  
  
  updatePatientHealthSubscription() {

  
    this.loaderService.show();
    this.user.employerId = 0;  // Assign 0 to empId
    // const isActive = this.activationType === 'Activate';  // True for "Activate", false for "Deactivate"
    this.activationType = "Activate";

    // Check if selectedType is valid and is 'Active'
    if (this.selectedPlan.id && this.activationType) {
      // Call the service to update the subscription
    // Navigate to the next component with the subscriptionType as a route parameter
 
      this.patientService
        .updatePatientHealthSubscription(
          this.user.patientId,
          this.user.employerId,
          this.selectedPlan.id,
          this.activationType
        )
        .subscribe(
          (res) => {
           if (res &&  res.resultStatus && res.resultStatus.isSuccess){
              this.subscriptionType = this.selectedPlan.id;
              this.activationType = this.activationType;
              this.utils.showMessageSnackBar(JSON.stringify(res));   
              this.utils.showMessageSnackBar('program subscribed successfully.');
              this.loaderService.hide();
              this.router.navigate(["/patient/subscription"]);
              document.getElementById("clsModal").click();

           

            } else{
              const errorMessage = res && res.resultStatus && res.resultStatus.errorMessages
        ? res.resultStatus.errorMessages.join(", ")
        : "Failed to fetch subscription details.";
      
      this.utils.showMessageSnackBar(errorMessage, true);
            }
            this.loaderService.hide();

          },
          (error) => {
            console.error("error while updating",error);
            this.loaderService.hide();
            this.utils.showMessageSnackBar(error.errorMessage,true);
            this.utils.showMessageSnackBar('please try again.');
          }
        );
    } else {
      // Handle invalid selectedType or inactive type
      console.log("Please select a valid active subscription type.");
      this.loaderService.hide(); // Hide loader in case of invalid selection
    }
  }

  pay() {
    this.updatePatientHealthSubscription();
  //  this.router.navigate(["/patient/subscriptions"]);

  }
  // pay() {
  //   this.loaderService.show();
  //   this.userService
  //     .chargeUserSubscriptionFee(this.selectedPlan.id)
  //     .subscribe(
  //       (res) => {
  //         console.log("payment response",res);


  //         // }
  //         if (res.resultStatus.success) {
  //           this.utils.showMessageSnackBar(
  //              JSON.stringify(res.resultStatus.message), // Message to show
  //             false,  // Success (not error)
  //             ['success-snackbar'],  // Success class
  //             'center',
  //             'bottom',
  //             3000  // Short duration for success
  //           );
  //          this.updatePatientHealthSubscription();
  //          this.router.navigate(["/patient/subscriptions"]);
  //         } else {
  //         // Check if errorMessages exist
  //         let errorMessage = "Transaction failed";
  //         if (res && res.resultStatus) {
  //           if (res.resultStatus.errorMessages && res.resultStatus.errorMessages.length > 0) {
  //             errorMessage = res.resultStatus.errorMessages.join(" ");
  //           } else if (res.resultStatus.message) {
  //             errorMessage = res.resultStatus.message;
  //           }
  //         }
  
  //         this.errorMessage = errorMessage;
  //         this.utils.showMessageSnackBar(this.errorMessage, true);
  //         }
  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         console.error(error);
  //         this.loaderService.hide();
  //         this.utils.showMessageSnackBar(error.error,true);

  //       },
  //       () => {
  //         this.loaderService.hide();
  //       }
  //     );
  // }
  GetPaymentInformation() {

      this.loaderService.blockWithLoader(this.userService.GetPaymentInformation("")).subscribe(data => {
        console.log("Payment Information", data);
        console.log("Credit Cards", data.profile.paymentProfiles);
        this.creditCards = data.profile.paymentProfiles;
        this.customerProfileId = data.profile.customerProfileId
      });
    
  }

    addCreditCard(): void {
      const dialogRef = this.dialog.open(CreditCardComponent, {
        // height: '45%',
        width: '748px',
        disableClose: true,
        data: this.customerProfileId ? this.customerProfileId : null
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res && res.data && res.data.resultStatus) {
          if (res.data.resultStatus.isSuccess) {
            this.utils.showMessageSnackBar('Credit card saved successfully.');
          }
          else {
            this.utils.showMessageSnackBar(res.data.resultStatus.message, true);
          }
        }
        this.GetPaymentInformation();
      });
    }

    openFamilyPopup(): void {
      const dialogRef = this.dialog.open(PatientFamilyDetailsComponent, {
        width: '400px',
      });
  
      dialogRef.afterClosed().subscribe((selectedMembers: any[]) => {
        if (selectedMembers) {
          this.familyCount = selectedMembers.length; // Update family count with the number of selected members
          console.log('Selected Family Members:', selectedMembers);
        }
      });
    }
}
